module.exports = __webpack_public_path__ + "static/media/emoji-smiling-face-with-smiling-eyes.35292f14.png";